import React from "react";
import { Link } from "react-router-dom";
import { FolderOpen, Copy, ArrowUpRight, Info } from "lucide-react";
import DashboardLayout from "../components/dashboard/DashboardLayout";

const Positions = () => {
  return (
    <DashboardLayout title="Positions" subtitle="Open trades" activeKey="positions">
      <div className="grid sm:grid-cols-3 gap-4 mb-5">
        <div className="bb-card rounded-2xl p-5">
          <div className="text-[11px] text-white/55 mb-1">Open positions</div>
          <div className="font-display text-[26px] font-bold tabular-nums">0</div>
        </div>
        <div className="bb-card rounded-2xl p-5">
          <div className="text-[11px] text-white/55 mb-1">Total volume</div>
          <div className="font-display text-[26px] font-bold tabular-nums">0.00 lots</div>
        </div>
        <div className="bb-card rounded-2xl p-5">
          <div className="text-[11px] text-white/55 mb-1">Floating P&amp;L</div>
          <div className="font-display text-[26px] font-bold tabular-nums text-white/60">
            $0.00
          </div>
        </div>
      </div>

      <div className="bb-card rounded-2xl p-8 lg:p-12 text-center" data-testid="positions-empty">
        <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-white/[0.04] border border-white/8 flex items-center justify-center">
          <FolderOpen size={22} className="text-white/55" />
        </div>
        <div className="font-display font-bold text-[20px] text-white mb-2">
          No open positions yet
        </div>
        <p className="text-[13px] text-white/55 max-w-md mx-auto leading-relaxed mb-6">
          You don't have any open trades. Mirror a top trader with Copy Trading and your positions will appear here automatically.
        </p>
        <Link
          to="/dashboard/copy-trading"
          className="inline-flex items-center gap-1.5 px-4 py-2.5 bb-blue text-white text-[13px] font-medium rounded-lg"
          data-testid="positions-copy-cta"
        >
          <Copy size={14} /> Browse traders <ArrowUpRight size={14} />
        </Link>

        <div className="mt-8 max-w-md mx-auto flex items-start gap-2.5 px-4 py-3 rounded-lg bg-white/[0.02] border border-white/8 text-left">
          <Info size={14} className="text-[#7d8eff] shrink-0 mt-0.5" />
          <div className="text-[11px] text-white/55 leading-relaxed">
            Manual trading from the terminal is launching soon. For now, open trades are managed via Copy Trading.
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Positions;
